import { ModalCloseButton, type StackProps } from '@chakra-ui/react';

export type UiModalCloseButtonProps = StackProps;

export const UiModalCloseButton = ModalCloseButton;
